import client from '../axios/client';

const notaEntradaMapeamentosApi = {
  // Listar notas de entrada de todos os tenants via VHsys
  listNotasEntrada: async (limit = 50, offset = 0) => {
    const response = await client.get('/nota-entrada/notas', { params: { limit, offset } });
    return response.data;
  },

  // Listar histórico de mapeamentos de uma nota de entrada específica
  listMapeamentosByNota: async (tenantId, idEntrada, limit = 50, offset = 0) => {
    const response = await client.get(`/nota-entrada/${tenantId}/${idEntrada}/mapeamentos`, { params: { limit, offset } });
    return response.data;
  },

  // Listar histórico de mapeamentos (geral)
  listMapeamentos: async (tenantId = null, limit = 50, offset = 0) => {
    const params = { limit, offset };
    if (tenantId) {
      params.tenantId = tenantId;
    }
    const response = await client.get('/nota-entrada', { params });
    return response.data;
  },

  // Obter detalhes de um mapeamento específico
  getMapeamentoById: async (id) => {
    const response = await client.get(`/nota-entrada/${id}`);
    return response.data;
  },

  // Iniciar um novo processo de mapeamento
  iniciarMapeamento: async (tenantId, idEntrada) => {
    const response = await client.post('/nota-entrada', {
      tenantId,
      idEntrada
    });
    return response.data;
  },

  /**
   * Cria regra de mapeamento de produto para todos os tenants.
   * Body: { tenantIdContext, idFornecedor, codProdutoFornecedor, codProdutoInterno, multiploQuantidade }
   */
  criarMapeamentoProduto: async (body) => {
    const response = await client.post('/nota-entrada/mapeamento-produto', body);
    return response.data;
  }
};

export default notaEntradaMapeamentosApi;



